import { AlertCircle, Eye, EyeOff, Loader2 } from "lucide-react";

import { Button } from "@workspace/web-ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@workspace/web-ui/components/form";
import { Input } from "@workspace/web-ui/components/input";
import { PasswordInput } from "@workspace/web-ui/components/password";

import { useLogin } from "~/features/auth/hooks/use-login";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@workspace/web-ui/components/card";
import { Image } from "@workspace/web-ui/components/image";

const inputStyles = "rounded-lg border border-[#DCDEE3]";
const inputStylesError = "rounded-lg border-red-500 focus:border-red-500 focus:ring-red-500";

import lockIcon from "~/assets/icons/lock.svg";
// import { Link } from "@tanstack/react-router";
import { cn } from "@workspace/web-ui/lib/utils";

export const LoginForm = () => {
  const { form, onSubmit, isLoading, error } = useLogin();

  return (
    <Card className="min-w-[200px] sm:w-[550px]">
      <CardHeader>
        <CardTitle className="text-[#1A202C] text-[32px] font-semibold text-center">Super Admin Mode</CardTitle>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6" aria-label="Login form">
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="text-[#1A202C] font-medium text-base">Email</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="Enter email address"
                      type="email"
                      autoComplete="email"
                      className={cn(inputStyles, form.formState.errors.email && inputStylesError, "px-[16px] py-[20px]")}
                      aria-label="Email address"
                      aria-invalid={!!form.formState.errors.email}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <div className="flex items-center justify-between">
                    <FormLabel className="text-[#1A202C] font-medium text-base">Password</FormLabel>
                    {/* <Link to="/reset-password" className="text-[#2A6BFF] font-medium underline text-base border-dotted">Reset Password?</Link> */}
                  </div>
                  <FormControl>
                    <PasswordInput
                      placeholder="Enter password"
                      type="password"
                      autoComplete="current-password"
                      className={cn(inputStyles, form.formState.errors.password && inputStylesError, "px-[16px] py-[20px]")}
                      aria-label="Password"
                      aria-invalid={!!form.formState.errors.password}
                      showIcon={<EyeOff size={16} />}
                      hideIcon={<Eye size={16} />}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button
              className="w-full px-[16px] py-[12px] h-10 rounded-[10px]bg-[#4272DD] rounded-[10px] bg-[#4272DD]"
              type="submit"
              disabled={isLoading}
              aria-busy={isLoading}
            >
              {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
              Login
            </Button>

            {error && (
              <div
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 p-2 text-red-500"
                role="alert"
                aria-live="polite"
              >
                <AlertCircle className="size-4" aria-hidden="true" />
                <p className="text-sm font-medium">{error}</p>
              </div>
            )}
          </form>
        </Form>
      </CardContent>
      <CardFooter className="flex items-center justify-center gap-2">
        <Image src={lockIcon} alt="Lock" layout="constrained" width={24} height={24} />
        <p>Secure Connection Established</p>
      </CardFooter>
    </Card>
  );
};
